import { Stack, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { use } from "react";
import { FormattedMessage } from "react-intl";

import { requireSignedIn } from "@features/auth/route-guards";
import { IdentityCard } from "@features/account/IdentityCard";
import { PasswordCard } from "@features/account/PasswordCard";
import { PlanCard } from "@features/account/PlanCard";
import { WorkspaceContext } from "@features/workspace/WorkspaceContext";
import { AppShell } from "@shared/components/layout/AppShell";

export const Route = createFileRoute("/account")({
  beforeLoad: requireSignedIn,
  component: AccountPage,
});

function AccountPage() {
  const workspace = use(WorkspaceContext);
  if (!workspace) return null;
  return (
    <AppShell.Root>
      <AppShell.TopBar />
      <AppShell.Content>
        <Stack gap={64} maw={640} m="0 auto" py={32}>
          <Title order={1} style={{ fontSize: 48, fontWeight: 400 }}>
            <FormattedMessage id="account.page.title" defaultMessage="Account" />
          </Title>
          <Stack gap={24}>
            <IdentityCard currentEmail={workspace.user.email} />
            <PasswordCard email={workspace.user.email} />
            <PlanCard />
          </Stack>
        </Stack>
      </AppShell.Content>
    </AppShell.Root>
  );
}
